import { graphql } from "react-relay";

export const createAnnotation = graphql`
  mutation annotationCreateAnnotationMutation(
    $description: String
    $dataFileId: String
    $flightId: String!
    $annotationCategoryId: String!
    $flightUtime: Float
    $eventTime: DateTime
    $videoUsec: Float
    $mediaGeojson: GeoJSON
    $connections: [ID!]!
  ) {
    createAnnotation(
      description: $description
      flightId: $flightId
      flightDataFileId: $dataFileId
      annotationCategoryId: $annotationCategoryId
      flightUtime: $flightUtime
      eventTime: $eventTime
      videoUsec: $videoUsec
      mediaGeojson: $mediaGeojson
    ) {
      annotation @appendNode(connections: $connections, edgeTypeName: "AnnotationEdge") {
        id
        uuid
        description
        flightDataFileId
        annotationCategory {
          uuid
          id
          name
        }
        mediaGeojson
      }
      errors
    }
  }
`;

export const createAnnotationCategory = graphql`
  mutation annotationCreateAnnotationCategoryMutation(
    $name: String!
    $orgId: ID!
    $categoryType: CloudApiAnnotationCategoryTypeAnnotationCategoryTypeEnum
    $connections: [ID!]!
  ) {
    createAnnotationCategory(name: $name, orgId: $orgId, categoryType: $categoryType) {
      annotationCategory
        @appendNode(connections: $connections, edgeTypeName: "AnnotationCategoryEdge") {
        id
        uuid
        name
        type
      }
      errors
    }
  }
`;

export const updateAnnotation = graphql`
  mutation annotationUpdateAnnotationMutation(
    $annotationId: ID!
    $description: String
    $annotationCategoryId: String
    $mediaGeojson: GeoJSON
  ) {
    updateAnnotation(
      description: $description
      annotationCategoryId: $annotationCategoryId
      nodeId: $annotationId
      mediaGeojson: $mediaGeojson
    ) {
      annotation {
        id
        uuid
        description
        annotationCategory {
          uuid
          id
          name
        }
        mediaGeojson
      }
      errors
    }
  }
`;

export const deleteAnnotation = graphql`
  mutation annotationDeleteAnnotationMutation($annotationId: ID!, $connections: [ID!]!) {
    deleteAnnotation(id: $annotationId) {
      removedAnnotationId @deleteEdge(connections: $connections)
      errors
    }
  }
`;

export const deleteAnnotationCategory = graphql`
  mutation annotationDeleteAnnotationCategoryMutation(
    $annotationCategoryId: ID!
    $connections: [ID!]!
  ) {
    deleteAnnotationCategory(id: $annotationCategoryId) {
      removedAnnotationCategoryId @deleteEdge(connections: $connections)
      errors
    }
  }
`;
